import i18n from "@src/common/lib/i18n";
import utils from "@src/common/utils";
export const tableOption = function () {
  return {
    add: "新增",
    edit: "修改",
    view: "查看",
    page: true,
    selection: true,
    index: true,
    indexLabel: "序号",
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: "：",
    align: "left",
    size: "small",
    maxHeight: "100%",
    labelWidth: "100px",
    labelPosition: "right",
    menuWidth: 200,
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 350,
    dialogWidth: "640px",
    emptyText: "暂无数据",
    menu: false,
    column: [
      {
        label: "司机姓名",
        prop: "driverName",
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: "center",
      },
      {
        label: "手机号",
        prop: "phone",
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: "center",
      },
      {
        label: "前车车牌",
        prop: "frontPlate",
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: "center",
      },
      {
        label: "预约园区",
        prop: "appointmentParkName",
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: "center",
      },
      {
        label: "预约到达时间",
        prop: "estimatedArrivalTime",
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        hide: true,
        align: "center",
        formatter: function (row, value) {
          return value
            ? utils.Dates.dayjs(value).format("YYYY-MM-DD HH:mm:ss")
            : "";
        },
      },
      {
        label: "作业类型",
        prop: "operateType",
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: "center",
        formatter: (row, value) => {
          if (value == '1') {
            return "装货";
          } else if (value == '2') {
            return "卸货";
          } else if (value == '3') {
            return "过车";
          }
          return "";
        },
      },
      {
        label: "客户",
        prop: "custom",
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: "center",
      },
      // {
      //   label: "柜号",
      //   prop: "cabinetNames",
      //   addDisplay: false,
      //   editDisplay: false,
      //   viewDisplay: true,
      //   editDisabled: false,
      //   overHidden: true,
      //   align: "center",
      // },
      {
        label: "申请时间",
        prop: "createTime",
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: "center",
        formatter: function (row, value) {
          return value
            ? utils.Dates.dayjs(value).format("YYYY-MM-DD HH:mm:ss")
            : "";
        },
      },
      // {
      //   label: "状态",
      //   prop: "workflow",
      //   slot: true,
      //   overHidden: true,
      //   align: "center",
      // },
      // {
      //   label: "状态",
      //   prop: "appointmentStatus",
      //   addDisplay: false,
      //   editDisplay: false,
      //   viewDisplay: true,
      //   editDisabled: false,
      //   overHidden: true,
      //   align: "center",
      //   formatter: (row, value) => {
      //     if (value == '0') {
      //       return "已提交（信息不全）";
      //     } else if (value == '1') {
      //       return "已申请（待审批）";
      //     } else if (value == '2') {
      //       return "已审批(待签到)";
      //     } else if (value == '3') {
      //       return "已签到（待调度）";
      //     } else if (value == '4') {
      //       return "已调度（待作业）";
      //     } else if (value == '5') {
      //       return "作业中";
      //     } else if (value == '6') {
      //       return "已完成作业（待申请离场）";
      //     } else if (value == '7') {
      //       return "已申请离场（出园客服待审批）";
      //     } else if (value == '8') {
      //       return "出园客服已审批（出园调度待审批）";
      //     } else if (value == '9') {
      //       return "出园调度已审批 （待放行出园）";
      //     } else if (value == '10') {
      //       return "已出园";
      //     } else if (value == '96') {
      //       return "取消预约";
      //     } else if (value == '97') {
      //       return "已拒绝";
      //     } else if (value == '98') {
      //       return "已作废";
      //     } else if (value == '99') {
      //       return "结束";
      //     }
      //     return "";
      //   },
      // },
      {
        label: "状态",
        prop: "appointmentStatusName",
        overHidden: true,
        align: "center",
      },
    ],
  };
};
